/**
 * @voltxampere/schema — Migration 0.3.0 → 0.4.0 (Sprint 9)
 *
 * Sprint 9 adds two additive fields to the simulation settings:
 *
 *   - `simulationSettings.dc.assertions?: string[]`
 *     DSL source strings to evaluate against the DC operating
 *     point.
 *   - `simulationSettings.transient.assertions?: string[]`
 *     DSL source strings to evaluate against the final transient
 *     sample (Sprint 9 baseline — per-sample evaluation lands in
 *     Sprint 13+ with the oscillation check).
 *
 * Both fields are optional, so pre-0.4.0 circuits migrate with
 * zero data touches — the migration just stamps the new
 * schemaVersion so subsequent tooling can dispatch on it.
 *
 * The richer Circuit-level `assertions` array (Sprint 6+) already
 * exists as `Assertion[{ id, expression, locale, enabled,
 * description? }]` and is unchanged. Settings-level assertions
 * are a convenience shortcut for analysis-kind-scoped checks
 * authored in the sim-settings panel rather than the dedicated
 * assertions panel.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const migration_0_3_0_to_0_4_0 = {
    from: "0.3.0",
    to: "0.4.0",
    description: "Sprint 9: additive DC/Transient settings-level assertion string arrays (DSL) — no data touches, schemaVersion stamp only",
    migrate(circuit) {
        if (typeof circuit !== "object" || circuit === null) {
            return circuit;
        }
        const raw = circuit;
        return { ...raw, schemaVersion: "0.4.0" };
    },
};
//# sourceMappingURL=0.3.0-to-0.4.0.js.map